import 'CssFolder/user.scss'
import ViewBase from '../../view-base.view';
import UserSearchView from './search/user-search.view';
import UserCreateView from './create/user-create.view';
import '../../../utils/extensions.js'
import UserBatchRegisterComponent from './create/user-batch-registration.view';

export default function UserView() {
  ViewBase.call(this);

  let tabButton = (txt, vw, type, icon = undefined) => {
    let activeClass = this.state.currentScreenNumber === type ? "btn-primary" : "btn-outline-primary";
    return m("a.btn[role=tablist]",
      {
        class: activeClass,
        onclick: () => {
          this.state.currentScreen = vw
          this.state.currentScreenNumber = type;
        } //UserCreateView
      },
      icon !== undefined && icon,
      txt
    )
  }

  return {
    oninit: (vnode) => {
      this.initState(vnode.state);
      this.state.currentScreen = UserSearchView;
      this.state.currentScreenNumber = 1;
    },
    view: () => {
      return [
        m('.row',
          m(".col-md-12",
            m(".d-flex.gap-3",
              tabButton(this.getText("LT00000001", "Search"), UserSearchView, 1, m('i.bi.bi-search')),
              tabButton(this.getText("LT00000017", "Register"), UserCreateView, 2, m('i.bi.bi-plus-lg')),
              tabButton(this.getText("LT00000580", "Batch Registration"), UserBatchRegisterComponent, 3, m('i.bi.bi-plus-lg')),
            ),
            m('hr.my-3', { style: 'background-color: var(--is-link-blue);' }),
            m("div",
              m(this.state.currentScreen, {
                onSaved: (result) => {
                  if (result && result.length > 0) {
                    this.showMessage(result[0].message, result[0].transStatus);
                  }
                  this.state.currentScreen = UserSearchView;
                  this.state.currentScreenNumber = 1;
                  setTimeout(() => {
                    this.state.currentScreen = UserCreateView;
                    this.state.currentScreenNumber = 2;
                  }, 100);
                }
              }),
            ),
          ),
        ),
        this.getBaseViews()
      ];
    }
  }
}
